import { formatDate } from '@angular/common';
import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { defaultTableDefOptions } from '../../helpers';
import { SubscriptionService } from '../../service/subscription.service';
import { BranchImpl, BundleSummary, BundleTransaction } from '../../types';

@Component({
  selector: 'app-bundle-transaction-history',
  templateUrl: './bundle-transaction-history.component.html',
  styleUrls: ['./bundle-transaction-history.component.scss'],
  standalone: false,
})
export class BundleTransactionHistoryComponent implements OnInit {
  private subscriptionService = inject(SubscriptionService);

  readonly branch = input<BranchImpl>(undefined);
  readonly triggerBundleRefresh = input<Subject<boolean>>(undefined);
  readonly bundleSummaryUpdated = output<BundleSummary[]>();

  isLoading = signal<boolean>(false);
  transactions = signal<BundleTransaction[]>([]);

  public readonly tableDef: GridOptions<BundleTransaction> = {
    ...defaultTableDefOptions(),
    pagination: true,
    paginationPageSize: 10,
    paginationPageSizeSelector: [10, 20, 50],
  };

  public readonly columnDefs: ColDef<BundleTransaction>[] = [
    {
      field: 'bundle',
      headerName: 'Bundle',
      cellDataType: 'text',
      filter: 'agTextColumnFilter',
    },
    {
      field: 'buy_date',
      headerName: 'Buy Date',
      cellDataType: 'date',
      filter: 'agDateColumnFilter',
      valueFormatter: (params) => formatDate(params.value, 'medium', 'en-US'),
    },
    {
      field: 'quantity',
      headerName: 'Total',
      cellDataType: 'text',
      filter: 'agNumberColumnFilter',
    },
    {
      field: 'actor',
      headerName: 'Actor',
      cellDataType: 'text',
      filter: 'agTextColumnFilter',
    },
  ];

  refreshBundleSummary() {
    this.isLoading.set(true);

    this.subscriptionService.getBundleTransactionHistory(this.branch().id).subscribe({
      next: (res) => {
        const transactions = res.map((t) => ({
          ...t,
          buy_date: new Date(t.buy_date),
        }));
        this.transactions.set(transactions);
      },
      complete: () => {
        this.isLoading.set(false);
      },
    });
  }

  ngOnInit(): void {
    this.refreshBundleSummary();
    this.triggerBundleRefresh().subscribe({
      next: () => {
        this.refreshBundleSummary();
      },
    });
  }
}
